// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j4Tfq","content":"styles_content__Dm9a-"};